var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewKnowledgebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "add-file-9",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M10,19a5,5,0,0,0-4-4.9H6V5a1,1,0,0,1,.29-.71l2-2A1,1,0,0,1,9,2H20a2,2,0,0,1,2,2V20a2,2,0,0,1-2,2H9A5,5,0,0,0,10,19Z",
    style: {
      fill: "#362f2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M4,21V20H3a1,1,0,0,1,0-2H4V17a1,1,0,0,1,2,0v1H7a1,1,0,0,1,0,2H6v1a1,1,0,0,1-2,0ZM9,2a1,1,0,0,0-.71.29l-2,2A1,1,0,0,0,6,5H8A1,1,0,0,0,9,4Z",
    style: {
      fill: "#362f2e"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewKnowledgebase);
export default __webpack_public_path__ + "static/media/new-knowledgebase.299e0835311eb16c16e400fcdaaf0de2.svg";
export { ForwardRef as ReactComponent };